export default __webpack_public_path__ + "media/images/mud-run-fun-card-title-9610bab724d9284cc13e47539fe3422d.svg";